import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=a256ae64&scoped=true&"
var script = {}
import style0 from "./NavTab.vue?vue&type=style&index=0&id=a256ae64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a256ae64",
  null
  
)

export default component.exports